"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pastena": {
    "cad30b81": [{
      "hkey": "cd36cb3d",
      "slug": "pastena",
      "name": "Pastena",
      "primary": true,
      "skipSearch": false
    }],
    "casanova": [{
      "hkey": "cd36cb3d",
      "slug": "pastena",
      "name": "Pastena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a7e72406": [{
      "hkey": "cd36cb3d",
      "slug": "pastena",
      "name": "Pastena",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "cd36cb3d",
      "slug": "pastena",
      "name": "Pastena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "207a8ad6": [{
      "hkey": "cd36cb3d",
      "slug": "pastena",
      "name": "Pastena",
      "primary": true,
      "skipSearch": false
    }],
    "grotte": [{
      "hkey": "cd36cb3d",
      "slug": "pastena",
      "name": "Pastena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;